module.exports = "pegasus_template/assets/blocks/header-6-theme3.png";